import * as React from 'react'

import { Slider } from 'main/ui'
import { IRangeProps } from 'main/ui/slider/RangeSlider'
import { IRankingFactorWeights } from 'main/util/search'
import { Apply, Clear, FormSubmitContainer, Label } from './Content.styles'

interface IProps {
  rankingWeights: IRankingFactorWeights
  defaultRankingWeights: IRankingFactorWeights
  onChangeRankingWeights: (searchRankingWeights: IRankingFactorWeights) => void
  onRequestClose: () => void
}

const sliderMaxValue = 1000

enum WeightType {
  DISTANCE = 'distance',
  FRESHNESS = 'freshness',
  TOURING = 'touring',
  TYPE = 'type',
  UTILIZATION = 'utilization',
}

export default function Content(contentProps: IProps) {
  const { defaultRankingWeights, rankingWeights, onChangeRankingWeights, onRequestClose } =
    contentProps
  const [params, setParams] = React.useState<IRankingFactorWeights>(rankingWeights)

  return (
    <>
      <Label>Distance</Label>
      <Slider
        maxValue={sliderMaxValue}
        value={weightValue(WeightType.DISTANCE)}
        onChange={value => handleWeightChange(value, WeightType.DISTANCE)}
      />
      <Label>Freshness</Label>
      <Slider
        maxValue={sliderMaxValue}
        value={weightValue(WeightType.FRESHNESS)}
        onChange={value => handleWeightChange(value, WeightType.FRESHNESS)}
      />
      <Label>Touring</Label>
      <Slider
        maxValue={sliderMaxValue}
        value={weightValue(WeightType.TOURING)}
        onChange={value => handleWeightChange(value, WeightType.TOURING)}
      />
      <Label>School type</Label>
      <Slider
        maxValue={sliderMaxValue}
        value={weightValue(WeightType.TYPE)}
        onChange={value => handleWeightChange(value, WeightType.TYPE)}
      />
      <Label>Utilization</Label>
      <Slider
        maxValue={sliderMaxValue}
        value={weightValue(WeightType.UTILIZATION)}
        onChange={value => handleWeightChange(value, WeightType.UTILIZATION)}
      />
      <FormSubmitContainer>
        <Clear to="#" onClick={() => handleClear()}>
          Clear
        </Clear>
        <Apply to="#" onClick={() => handleApply()}>
          Apply
        </Apply>
      </FormSubmitContainer>
    </>
  )

  function weightValue(weight: WeightType) {
    return params[weight] === null ? sliderMaxValue : params[weight] * 1000
  }

  function handleWeightChange(value: IRangeProps | number, weight: WeightType) {
    if (typeof value !== 'number') {
      throw new Error('value must be number')
    }

    setParams({ ...params, [weight]: value / 1000 })
  }

  function handleApply() {
    onRequestClose()
    onChangeRankingWeights({ ...rankingWeights, ...params })
  }

  function handleClear() {
    setParams({ ...defaultRankingWeights })
  }
}
